import { Injectable } from '@angular/core';
import { EventTypeFilter, EventTypeDetails, EventTypeWM } from './meta.types';
import { HttpClient } from '@angular/common/http';
import { PagedList } from '../common/common.types';
import { getParams } from '../common/common.func';

@Injectable()
export class EventTypeService {
	private eventTypesUrl = 'api/eventTypes';
	private pagedTypesUrl = `${this.eventTypesUrl}/pagedEventTypes`;

	constructor(private http: HttpClient) { }

	getEventType(eventTypeId: number): Promise<EventTypeDetails> {
		return this.http.get<EventTypeDetails>(`${this.eventTypesUrl}/${eventTypeId}`)
				.toPromise();
	}

	getPagedEventTypes(eventTypeFilter?: EventTypeFilter): Promise<PagedList<EventTypeDetails>> {
		const params = getParams(eventTypeFilter);
		return this.http.get<PagedList<EventTypeDetails>>(this.pagedTypesUrl, { params: params } )
			.toPromise();
	}

	createEventType(eventType: EventTypeWM): Promise<number> {
		return this.http.post<number>(this.eventTypesUrl, eventType)
			.toPromise();
	}
	updateEventType(eventTypeId: number, updatedEventType: EventTypeWM): Promise<void> {
		return this.http.put<void>(`${this.eventTypesUrl}/${eventTypeId}`, updatedEventType)
			.toPromise();
	}
	archiveEventType(eventTypeId?: number): Promise<void> {
		return this.http.delete<void>(`${this.eventTypesUrl}/${eventTypeId}`).toPromise();
	}
}
